module.exports = __webpack_public_path__ + "5ba38eedbe79e660874b2fa048396215.pdf";